import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import "./index.scss";

class CustomWebpageBar extends Component {
  handleNavigateToExternalWebpage = evt => {
    evt.preventDefault();

    const { displayText, onNavigateToExternalPage } = this.props;
    const html = new DOMParser().parseFromString(displayText, "text/html");
    const href = html.querySelector("a").getAttribute("href");

    onNavigateToExternalPage(href);
  };

  render() {
    const { isExternalPage, displayText, onReturnToKiosk, t } = this.props;

    if (isExternalPage)
      return (
        <div className="CustomWebpageBar">
          <div className="header-title">{t("kiosk_return_to_the").message || "Return to the"}</div>
          <div className="header-title-link" onClick={onReturnToKiosk}>
            {t("kiosk_claire_kiosk").message || "Claire Kiosk"}
          </div>
        </div>
      );

    if (!displayText) return null;

    return <div className="CustomWebpageBar" dangerouslySetInnerHTML={{ __html: displayText }} onClick={this.handleNavigateToExternalWebpage}></div>;
  }
}

export default withTranslation()(CustomWebpageBar);
